import React from "react";
import { useIsDesktop } from "@/hooks/useMediaQuery";
import { NotificationsPageDesktop } from "./NotificationsPage.Desktop";
import { NotificationsPageMobile } from "./NotificationsPage.Mobile";

/** Inbox of price alerts, trades, listings and account updates, with their settings. */
export const NotificationsPage: React.FC = () => {
  const isDesktop = useIsDesktop();
  return isDesktop ? <NotificationsPageDesktop /> : <NotificationsPageMobile />;
};
